import { Footer } from "./Footer.tsx";
import type { PropsWithChildren } from "react";
import classNames from "classnames";

export type PageProps = PropsWithChildren & {
  title?: React.ReactNode | undefined;
  showFooter?: boolean;
};

export function PageFullHeight({
  title,
  children,
  showFooter = true,
}: PageProps) {
  return (
    <div className={"w-full max-h-full min-h-full h-full"}>
      <div
        className={classNames(
          "full-height-page h-full grid gap-4",
          title !== undefined
            ? "grid-rows-[auto_1fr_auto]"
            : "grid-rows-[1fr_auto]",
        )}
      >
        {title}
        {/*min-h-0 => schrumpfbar, flex + gap for inhalt*/}
        <div className={"h-full overflow-hidden"}>{children}</div>
        {showFooter && <Footer />}
      </div>
    </div>
  );
}
